import type { ChatUi } from '@voll-intelligence/genui-contract';
import type { GenUiDispatch } from '../../shared/ui/action.js';
import { useGenUiI18n } from '../../shared/ui/i18n.js';
import type { GenUiEntry } from '../../shared/ui/registry.js';
import { RentalPlannerCard, rentalSearchTranscript } from './ui/rental_planner.js';

type RentalPlannerUi = Extract<ChatUi, { kind: 'rental_planner' }>;

/**
 * A busca volta por `interaction` (o challenge do card + a `RentalPlannerSearch`):
 * o agente busca com os lugares do card, sem o LLM reinterpretar o texto. O eco
 * é a fala que a pessoa aparenta ter dito — por isso é traduzido aqui, num
 * componente (o `render` do catálogo não roda hook).
 */
function RentalPlannerEntry({
  ui,
  note,
  readOnly,
  superseded,
  replay,
  dispatch,
}: Readonly<{
  ui: RentalPlannerUi;
  note?: string;
  readOnly?: boolean;
  superseded?: boolean;
  replay?: boolean;
  dispatch: GenUiDispatch;
}>) {
  const i18n = useGenUiI18n();
  return (
    <RentalPlannerCard
      ui={ui}
      {...(note ? { note } : {})}
      {...(readOnly ? { readOnly } : {})}
      {...(superseded ? { superseded } : {})}
      {...(replay ? { replay } : {})}
      onSearch={(search) => {
        dispatch({
          type: 'interaction',
          interactionId: ui.challengeId,
          text: rentalSearchTranscript(i18n, search),
          data: search,
        });
      }}
    />
  );
}

/** Entrada de catálogo do `rental_planner` (slot chat). */
export const rentalPlannerEntry: GenUiEntry<RentalPlannerUi> = {
  kind: 'rental_planner',
  slot: 'chat',
  policy: { productOf: () => 'rental' },
  render: ({ ui, note, readOnly, superseded, replay, dispatch }) => (
    <RentalPlannerEntry
      ui={ui}
      {...(note ? { note } : {})}
      {...(readOnly ? { readOnly } : {})}
      {...(superseded ? { superseded } : {})}
      {...(replay ? { replay } : {})}
      dispatch={dispatch}
    />
  ),
};
